import type { ShiftEvent } from '@libs/data-access/queries'
import type { FC } from 'react'

import { LocationControlBadge } from './LocationControlBadge'
import { SignAndPictureControlBadges } from './SignAndPictureControlBadges'

type ControlBadgesProps = {
  event: ShiftEvent
}

export const ControlBadges: FC<ControlBadgesProps> = ({ event }) => {
  if (event.device_type === 'mobile') {
    return <LocationControlBadge event={event} />
  }

  return <SignAndPictureControlBadges event={event} />
}
